import React, { useEffect } from 'react';
import './App.css';
import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import About from './components/About';
import Products from './components/Products';
import ConsultArticles from './components/ConsultArticles';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ClientTestimonials from './components/ClientTestimonials';
import UsInAction from './components/UsInAction';

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show'); // Add animation class
          } 
        });
      },
      { threshold: 0.1 } // Trigger when 20% of the element is visible
    );

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect(); // Cleanup on component unmount
  }, []);

  return (
    // Homepage content
    <div className="App">
      <NavBar />
      <HeroSection />
      <div id="about" className="hidden">
        <About />
      </div>
      <div id="products" className="hidden">
        <Products />
      </div>
      <div id="in-action" className="hidden">
        <UsInAction />
      </div>
      <div id="client-testimonials" className="hidden">
        <ClientTestimonials />
      </div>
      <div id="consult-articles" className="hidden">
        <ConsultArticles />
      </div>
      <div id="cta" className="hidden">
        <CTA />
      </div>
      <div id="footer" className="hidden">
        <Footer />
      </div>
    </div>
  );
}

export default App;
